import type { ICartCookie, ICartCookieProduct } from '../model/types'

interface ICartCookieRestoreState {
  products: ICartCookieProduct[]
  shouldClearCookie: boolean
}

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

const normalizeCartCookieProduct = (value: unknown): ICartCookieProduct | null => {
  if (!isObject(value) || typeof value.id !== 'number') {
    return null
  }

  const product = value as Partial<ICartCookieProduct>
  const selectedModifiers = Array.isArray(product.selectedModifiers)
    ? product.selectedModifiers.filter((modifier): modifier is number => typeof modifier === 'number')
    : undefined

  return {
    ...product,
    id: product.id,
    selectedModifiers
  } as ICartCookieProduct
}

export const getCartCookieRestoreState = (
  cartCookie: unknown,
  restName: string
): ICartCookieRestoreState => {
  if (!isObject(cartCookie)) {
    return { products: [], shouldClearCookie: false }
  }

  const cookie = cartCookie as ICartCookie
  if (cookie.restaurant !== restName) {
    return { products: [], shouldClearCookie: false }
  }

  if (!cookie.products) {
    return { products: [], shouldClearCookie: false }
  }

  if (!Array.isArray(cookie.products)) {
    return { products: [], shouldClearCookie: true }
  }

  const products = cookie.products
    .map(normalizeCartCookieProduct)
    .filter((product): product is ICartCookieProduct => product !== null)

  return {
    products,
    shouldClearCookie: products.length !== cookie.products.length
  }
}
